import ConversationActionCreators from '../actions/ConversationActionCreators.js';
import ConversationStore from '../stores/ConversationStore';
import MessageStore from '../stores/MessageStore';
import get from 'lodash/get';

let statusUpdatesCount = 0;
// vēstuļu sadaļa
// Pieprasa serverim lietotāja pašreizējos parametrus
var statusUpdates = function (init, forced) {
  self.setTimeout(() => {
    if (!document.getElementById('messages')) {
      return false;
    }
    statusUpdates();
  }, 5000);
  
  // Vecajām aplikācijām nebūs websocket vai ja sūtītājam nav websocket
  /*
  if (MessageStore.getWebSocket()) {
    return;
  }
  */

  if (typeof init === 'undefined' && !init) {
    const firstConversation = ConversationStore.getFirst();
    const updateMembers = false;
    let updated = null;

    if (firstConversation) {
      updated = firstConversation.get('updated');
    }

    // lietotāju datus atjauno ik pēc 5 reizēm
    if (statusUpdatesCount == 5) {
      // updateMembers = true;
      statusUpdatesCount = 0;
    }
    ConversationActionCreators.conversationsLoad(updated, 'greater', true, false, updateMembers, true);
    statusUpdatesCount++;
  }
};

// atvērts profils
// Pieprasa serverim lietotāja pašreizējos parametrus
var statusUpdatesMessages = function (init, forced) {
  self.setTimeout(() => {
    if (!document.getElementById('private-messages')) {
      return false;
    }
    statusUpdatesMessages();
  }, 5000);

  // Vecajām aplikācijām nebūs websocket vai ja sūtītājam nav websocket
  /*
  if (MessageStore.getWebSocket()) {
    return;
  }
  */

  if (typeof init === 'undefined' && !init) {
    const newestMessage = MessageStore.getLastMessage(get(globals, 'memberId', null));

    if (newestMessage) {
      ConversationActionCreators.updateMessages(get(globals, 'memberId', null), newestMessage.get('created'));
    }
  }
};

module.exports = {
  init() {
    statusUpdates(true);
  },
  messages() {
    statusUpdatesMessages(true);
  },
};
